import { render, staticRenderFns } from "./AccountTags.vue?vue&type=template&id=574ca883&"
import script from "./AccountTags.vue?vue&type=script&lang=js&"
export * from "./AccountTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports